import config from '@/utils/config';
/* eslint-disable quote-props */

const { isModeSollers } = config.workMode;

export default {
  'users': (interfaces) => interfaces.business || interfaces.security,
  'logs': (interfaces) => interfaces.business || interfaces.security,
  'dealers': (interfaces) => interfaces.business && interfaces.read,
  'dealer/:asdb?': (interfaces) => !isModeSollers || (interfaces.business && interfaces.read),
  'emails': (interfaces) => interfaces.business && interfaces.security,
  'emails/list': (interfaces) => interfaces.business && interfaces.read,
  'emails/list/:id': (interfaces) => interfaces.business && interfaces.read,
  'emails/templates': (interfaces) => interfaces.business && interfaces.read,
  'emails/templates/:name': (interfaces) => interfaces.business && interfaces.read,
  'content': (interfaces) => interfaces.business,
  'content/list/news': (interfaces) => interfaces.business,
  'content/list/special-offers': (interfaces) => interfaces.business,
  'content/list/top': (interfaces) => interfaces.business,
  'content/help': () => true,
  'content/edit/:id/:type': (interfaces) => interfaces.business,
  'content/add/:type': (interfaces) => interfaces.business,
  'content/page/:id/:type': (interfaces) => interfaces.business && interfaces.read,
  'suppliers': (interfaces) => interfaces.business && interfaces.read,
  'supplier/:asdb?': (interfaces) => interfaces.read || interfaces.security,
  'supplier-contacts': (interfaces) => interfaces.business && interfaces.read,
  'orders': (interfaces) => interfaces.read,
  'requests': (interfaces) => !isModeSollers && interfaces.read,
  'complaints': (interfaces) => !isModeSollers && interfaces.read,
  'reports': (interfaces) => !isModeSollers && interfaces.read,
  'reports/complaints': (interfaces) => !isModeSollers && interfaces.read,
  'reports/settlement': (interfaces) => !isModeSollers && interfaces.read,
  'roles': (interfaces) => interfaces.business && interfaces.security,
  'files': (interfaces) => interfaces.read || interfaces.security,
  'versions': (interfaces) => interfaces.full,
  'queues-list': (interfaces) => interfaces.full,
};
